<div class="card mt-2">
  <div class="card-body">
    Fill form below to add the credit:
    <app-create-students-credits-bundle [schoolId]="schoolId" [studentId]="studentId"></app-create-students-credits-bundle>
    <app-student-purchase-history [schoolId]="schoolId" [studentId]="studentId" ></app-student-purchase-history>
    <app-student-transactions [studentId]="studentId" [schoolId]="schoolId"></app-student-transactions>
  </div>
</div>
